{
  "name": "de-wmedia-pps-frontend",
  "version": "1.0.0 RC2 20260929 1915",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --configuration=local --port 4208 --open --proxy-config localdev.proxy.conf.json",
    "start-phm-dev": "ng serve --configuration=pps-phm-portxx-dev --port 4207 --open --proxy-config phmportxxdev.proxy.conf.json",
    "start-ndt-dev": "ng serve --configuration=pps-ndt-local --port 4209 --open --proxy-config ndtlocaldev.proxy.conf.json",
    "build": "ng build --source-map",
    "build-dev": "ng build --c pps-dev",
    "build-uat": "ng build --c pps-uat",
    "build-prod": "ng build --c pps-prod",
    "build-demo-dev": "ng build --c pps-demo-dev",
    "build-ndt-dev": "ng build --c pps-ndt-dev",
    "build-ndt-uat": "ng build --c pps-ndt-uat",
    "build-phm-portxx-dev": "ng build --c pps-phm-portxx-dev",
    "build-phm-portxx-uat": "ng build --c pps-phm-portxx-uat",
    "watch": "ng build --watch --configuration pps-dev",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^17.3.12",
    "@angular/cdk": "^17.3.10",
    "@angular/common": "^17.3.12",
    "@angular/compiler": "^17.3.12",
    "@angular/core": "^17.3.12",
    "@angular/forms": "^17.3.12",
    "@angular/platform-browser": "^17.3.12",
    "@angular/platform-browser-dynamic": "^17.3.12",
    "@angular/router": "^17.3.12",
    "@cds/core": "^6.15.1",
    "@clr/angular": "^17.6.0",
    "@clr/ui": "^17.6.0",
    "@jsverse/transloco": "^7.6.1",
    "@jsverse/transloco-utils": "^7.0.2",
    "file-saver": "^2.0.5",
    "jszip": "^3.10.1",
    "moment": "^2.30.1",
    "ngx-extended-pdf-viewer": "^23.0.0-alpha.0",
    "pdfmake": "^0.2.18",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "xlsx": "0.18.5",
    "zone.js": "~0.14.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^17.3.12",
    "@angular/cli": "^17.3.12",
    "@angular/compiler-cli": "^17.3.12",
    "@types/file-saver": "^2.0.7",
    "@types/jasmine": "~5.1.0",
    "@types/pdfmake": "^0.2.11",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.4.2"
  }
}
